<template>
    <div>
        <v-dialog 
            width="500"
            persistent
            v-model="display">
            <v-card dark color="error">
                <v-card-title>{{ $t("error_title") }}</v-card-title>
                <v-card-text>
                    <!-- <div v-if="errors.length != 0">
                        <v-list dense dark color="error" >
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon>mdi-alert-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ message }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-for="(error, index) in errors" :key="index">
                                <v-list-item-icon>
                                    <v-icon>mdi-alert-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ error }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </div> -->
                    <div>
                        <v-list dense dark color="error" >
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon>mdi-alert-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ message }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn text dark @click="submit(true)">
                        <v-icon>mdi-refresh</v-icon>
                        {{ $t("TRY_AGAIN") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="submit(false)" dark>
                        <v-icon>mdi-exit-to-app</v-icon>
                        {{ $t("close_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
export default {
    name: "RetryDialog",
    // props: {
    //     errors: Array
    // },
    data() {
        return {
            display:false,
            message:null,
            target: null,
            errors: []
        }
    },
    computed:{

    },
    methods: {
        open(params){
            this.target = params.target;
            this.message = params.message;
            this.errors = params.errors;
            this.display = true;
        },
        close(){
            this.display = false;
            this.message = null;
        },
        submit(retry){
            this.$emit("submit", {target: this.target, retry});
            this.close();
        }
    }
}
</script>